module.exports = __webpack_public_path__ + "img/s2P30.94f18009.png";